import { faCalendar, faClock, faTachometerAlt } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useAppSelector } from 'app/config/store';
import { NoImage } from 'app/shared/components/no-image/NoImage';
import React from 'react';
import { openFile, translate } from 'react-jhipster';
import { Modal, ModalBody, ModalHeader } from 'reactstrap';
import '../../modules/part/part.scss';

export const PartModal = ({ part, toggle, isOpen }) => {
  const selectPart = useAppSelector(state => state.part.entity);

  const SectionValues = [
    {
      name: translate('fleetSenseApp.part.km'),
      icon: faTachometerAlt,
      value: part.cycleKm ?? '-',
    },
    {
      name: translate('fleetSenseApp.part.period'),
      icon: faCalendar,
      value: part.cycleDate ?? '-',
    },
    // {
    //   name: 'Horas de operação',
    //   icon: faClock,
    //   value: part.cycleHour ?? '-',
    // },
  ];

  const { image, name, description } = part;

  const lastImage = image ?? selectPart.image;

  return (
    <>
      <Modal className="modal-parts" isOpen={isOpen} toggle={toggle} zIndex={999999}>
        <ModalHeader toggle={toggle} title={name}>
          {name}
        </ModalHeader>
        <ModalBody>
          <div className="align-image">
            {lastImage ? (
              <a className="modal-image" title={name} onClick={openFile('image/jpeg', lastImage)}>
                <img src={`data:image/*;base64,${lastImage}`} alt="imagem-peça" />
              </a>
            ) : (
              <NoImage />
            )}
          </div>

          <div className="modal-title-values">
            <strong>
              Vida útil esperada <br />
            </strong>
          </div>
          <div className="part-values">
            {SectionValues.map((item, index) => (
              <React.Fragment key={index}>
                <div className="col-3 part-data-value">
                  <FontAwesomeIcon icon={item.icon} style={{ color: '#2cb4b4' }} />
                  <p style={{ color: '#2cb4b4' }}>{item.name}</p>
                  <span>
                    <p>
                      <strong>{item.value}</strong>
                    </p>
                  </span>
                </div>
              </React.Fragment>
            ))}
          </div>
          <div className="modal-description-part">
            <div className="modal-title-description">
              <strong>
                Descrição <br />
              </strong>
            </div>
            <div className="modal-description-text">{description}</div>
          </div>
        </ModalBody>
      </Modal>
    </>
  );
};

export default PartModal;
